var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"VOLUME_UP","name":"VOLUME_UP","data-vcode":"VolumeUp","disabled":"","aria-label":`${_vm.$t('volumeUp')}`}},[_c('img',{attrs:{"src":"/images/icons/volumeUp.svg","alt":""}}),_c('label',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.$t('volumeUp')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }